import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=6f479d3d&scoped=true"
import script from "./GoodsDetail.vue?vue&type=script&lang=ts"
export * from "./GoodsDetail.vue?vue&type=script&lang=ts"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=6f479d3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f479d3d",
  null
  
)

export default component.exports